import { useEffect, useState } from 'react'

export function useIsMobile(breakpoint = 768) {
  // Démarre sur `false`, comme le prérendu (qui tourne sans `window`).
  // Lire `window.innerWidth` ici forcerait un recalcul de mise en page
  // synchrone en pleine phase de rendu React, sur chaque instance du hook,
  // et désynchroniserait le premier rendu client du HTML prérendu (React #418).
  // La vraie valeur arrive juste après, via matchMedia, qui ne force aucun layout.
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined') return
    const mq = window.matchMedia(`(max-width: ${breakpoint - 1}px)`)
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches)
    setIsMobile(mq.matches)
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [breakpoint])

  return isMobile
}
